// BRK-S138 — how an ABSENT value reads on a record.
//
// The Commercial account card renders a bare em dash for a field nobody filled
// in. On a Surety account PROFILE that is not enough: the page is what a broker
// reads to Signal over the phone, and an em dash cannot be told apart from a
// rendering bug — "is the website missing from the record, or from the screen?"
// is exactly the ambiguity `formatBondValue`'s own header names about
// half-rendered addresses.
//
// So the profile says it in words. One constant, because a phrase repeated per
// field is a phrase that eventually differs by a hyphen.

/** What a field with no value reads as on a Surety profile. */
export const NOT_PROVIDED = "— not provided";

/**
 * A value as it renders, or `NOT_PROVIDED`.
 *
 * Blank-after-trim counts as absent: a stored `" "` is not an answer, and
 * rendering it leaves the row looking like a rendering bug — which is the whole
 * thing this exists to avoid.
 *
 * Takes `unknown` rather than `string | null` so a caller need not pre-narrow a
 * nullable read; anything that is not a non-blank string is absent. A NUMBER is
 * deliberately not stringified here — a figure needs a format decision
 * (currency, percent, a count), and the format belongs to the caller that knows
 * which (D-10).
 */
export function orNotProvided(value: unknown): string {
  return typeof value === "string" && value.trim() !== ""
    ? value
    : NOT_PROVIDED;
}
